import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import URLSearchParams from 'url-search-params'

import { addReferralCode } from 'modules/users/sign_up'

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => bindActionCreators({ addReferralCode }, dispatch)

const withRef = WrappedComponent => {
  return connect(mapStateToProps, mapDispatchToProps)(
    class Ref extends Component {
      componentWillMount() {
        const { addReferralCode } = this.props
        const ref = new URLSearchParams(window.location.search).get('ref')
        ref && addReferralCode(ref)
      }

      render() {
        return <WrappedComponent {...this.props} />
      }
    }
  )
}

export default withRef



// WEBPACK FOOTER //
// ./src/containers/hocs/ref.js